import { render } from "./SystemAdvisory.vue?vue&type=template&id=577c7714"
import script from "./SystemAdvisory.vue?vue&type=script&lang=js"
export * from "./SystemAdvisory.vue?vue&type=script&lang=js"

import "./SystemAdvisory.vue?vue&type=style&index=0&id=577c7714&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__